import { Avatar, Tab, Tabs } from '@mui/material'

type WizardStep = 'details-courses' | 'users' | 'review'

type WizardStepConfig = {
  step: WizardStep
  label: string
}

type WizardNavigationProps = {
  currentStep: WizardStep
  onStepChange: (step: WizardStep) => void
  canProceedToStep?: (step: WizardStep) => boolean
}

export default function WizardNavigation({
  currentStep,
  onStepChange,
  canProceedToStep,
}: WizardNavigationProps) {
  let steps: WizardStepConfig[] = [
    { step: 'details-courses', label: 'Details & Courses' },
    { step: 'users', label: 'Select Users' },
    { step: 'review', label: 'Review' },
  ]

  return (
    <Tabs value={currentStep} variant="fullWidth">
      {steps.map((tab, i) => (
        <Tab
          key={tab.step}
          value={tab.step}
          label={tab.label}
          onClick={() => onStepChange(tab.step)}
          disabled={canProceedToStep ? !canProceedToStep(tab.step) : false}
          iconPosition="start"
          icon={
            <Avatar
              sx={{
                width: 24,
                height: 24,
                fontSize: 16,
                color: currentStep === tab.step ? 'white' : 'text.secondary',
                bgcolor:
                  currentStep === tab.step
                    ? 'primary.main'
                    : 'background.paper',
                border: currentStep === tab.step ? 'none' : '2px solid',
                borderColor: 'divider',
              }}
            >
              {i + 1}
            </Avatar>
          }
          sx={{
            gap: 1,
            py: 2,
            textTransform: 'none',
            fontSize: '0.875rem',
            fontWeight: currentStep === tab.step ? 600 : 400,
          }}
        />
      ))}
    </Tabs>
  )
}
